<template> 
  <v-container fluid class="page-content">
    <div class="about">
      <h1>This is an about page</h1>
    </div>
  </v-container>
</template>